import { ViewChild, Component, OnInit, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { SharedPoint, SharedSeries } from "src/app/models/dashboard";

import * as Highcharts from "highcharts/highstock";
import theme from 'highcharts/themes/brand-dark';
import { Widget } from 'src/api/models';
theme(Highcharts);

@Component({
  selector: "app-size-comparison-widget",
  templateUrl: "./pie-chart-widget.component.html",
  styleUrls: ["./pie-chart-widget.component.css"],
})
export class PieChartWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges, DoCheck {
  
  Highcharts = Highcharts;
  chart: Highcharts.Chart;
  chartCallback: Highcharts.ChartCallbackFunction;
  chartOptions?: Highcharts.Options;
  public override widget: any;

  private colours: string[];

  offset: number;
  public c: any;
  public w: any;
  showValue: boolean;

  liveDataOnly(): boolean {
    return (<any>this.widget).period == null || (<any>this.widget).period == "";
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }

  widgetBeforeInit() {
    this.w = this.widget;
  }

  widgetAfterInit() {
    // get the offset from UTC to Local in milliseconds
    this.offset = -(new Date().getTimezoneOffset() * 60 * 1000);
    var series = [];
    this.showValue = false;
    this.c = <any>this.config;
    
    const widgetType = this.c.type;
    var currentTime = new Date();

    this.colours = [
      '#2f7ed8', '#8bbc21', '#910000', '#1aadce',
      '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a',
      "#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9",
      "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"
    ];

    for (var i in this.config.timeSeriesList) {
      var ts = <any>this.config.timeSeriesList[i];
      if (ts.colour == null){
        ts.colour = this.colours[i];
      }
      let markerState = false;
      if(ts.showMarker){
        markerState = ts.showMarker == null ? true : ts.showMarker;
      }
      //if the lineWidth is 0, marker will be shown
      if(ts.size==0){
        markerState = true;  
      }
    }

    var c = <any>this.config;
    var currentTime = new Date();
    var minTime = new Date(c.from).getTime();
    var maxTime = new Date(c.to).getTime();
    if (c.period == null || c.period == ''){
      minTime = new Date(this.dashboard.from).getTime();
      maxTime = new Date(this.dashboard.to).getTime();
    }

    this.chartOptions = ({
      chart: {
        backgroundColor: "transparent",
        type: 'pie',
        height:'90%'
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      time: {
        timezoneOffset: new Date().getTimezoneOffset()
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
            dataLabels: {
                enabled: true,
                distance: -20,
                format: '{point.percentage:.0f}%',
                style: {
                    fontSize: '0.9em'
                }
            },
            showInLegend: true
        }
      },
      tooltip: {
        shared: true,
        pointFormat: 'Percentage: <b>{point.percentage:.1f}%</b></br>' +
        'Value: <b>{point.y:.1f}</b>'
      },
      series: [{
        name: this.c.name,
        colorByPoint: true
      } as Highcharts.SeriesOptionsType],
    });

    this.chartCallback = chart => {
      this.chart = chart;
    }
  }

  refresh() {
    this.ngOnInit();
  }

  widgetDataLoadTimeout(){
    this.chart.hideLoading();
  }

  widgetLiveDataLoaded(s: any) {
    
    if (this.chart && this.chart.series) {
      if (s != null && s.uri != null){
        var item = <any>this.config.timeSeriesList.find(i => i.uri == s?.uri);
        //  var item = <any>this.config.timeSeriesList[s.index];
        item.uri = s.uri;
        item.index = s.index;
        item.value = s.point.value;

        // find chart series reference related to the data loaded
        var cseries = this.chart.series[0];
        
        var data: any[] = [];
        for (let i of this.config.timeSeriesList as any[]){
          data.push({uri: i.uri, name: i.name == null ? i.uri : i.name, y: i.value });
        }
        
        if (cseries) {
          cseries.setData(data);
        }
      }
    }
  }

  widgetDataLoaded(s: SharedSeries) {

    if (this.chart && this.chart.series) {
      if (this.c.showCategories)
      {
        console.log('showin categories');
        const j = JSON.parse(s.values[0].value);
        const dv = this.c.timeSeriesDetailList[0].displayValue;

        const data = [];
        for (let name in j)
        {
          data.push({"name":name, "y":j[name][dv]});
        }

        const cseries = this.chart.series[0];
        if (cseries) {
          cseries.setData(data);
        }
      }
      else{
        //todo working for multiple time series without categories?
        
      }
      
    }

  }

 
  widgetDataAdded(s: SharedPoint) {
  
  }

  ngDoCheck() {

  }

  ngOnChanges(changes: SimpleChanges) {
  }

}
